export const definePromiseAllsettled = () => {
  if (!Promise.allSettled) {
    // @ts-ignore
    Promise.allSettled = (promises) => {
      return Promise.all(
        promises.map((p) =>
          Promise.resolve(p).then(
            (value) => ({
              state: 'fulfilled',
              value,
            }),
            (reason) => ({
              state: 'rejected',
              reason,
            }),
          ),
        ),
      );
    };
  }
};

export default {
  definePromiseAllsettled,
};
